import { render, staticRenderFns } from "./WorkOrderSource.vue?vue&type=template&id=0c4fc79e&scoped=true"
import script from "./WorkOrderSource.vue?vue&type=script&lang=js"
export * from "./WorkOrderSource.vue?vue&type=script&lang=js"
import style0 from "./WorkOrderSource.vue?vue&type=style&index=0&id=0c4fc79e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4fc79e",
  null
  
)

export default component.exports